import SageButton from "kit/SageButton";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import createTeamInviteStatusSelector from "selectors/createTeamInviteStatus";

interface Props {
    teamId: string;
}

const AddMemberDialog: React.FC<Props> = ({ teamId }) => {
    const dispatch = useDispatch();
    const status = useSelector(createTeamInviteStatusSelector);
    const [email, setEmail] = React.useState("");

    const onFormSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            dispatch({
                type: "com.sage.actions.team.ICreateTeamInvite",
                teamId: teamId,
                email: email,
            } as sage.actions.team.ICreateTeamInvite);
        },
        [dispatch, teamId, email]
    );

    const onEmailChanged = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setEmail(e.target.value);
        },
        [setEmail]
    );

    return (
        <div className="modal fade" id="addMemberModal" aria-hidden={true}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Member</h5>
                    </div>
                    <form onSubmit={onFormSubmit}>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    value={email}
                                    onChange={onEmailChanged}
                                    className="form-control"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <SageButton
                                type="submit"
                                text={
                                    status !== "loading"
                                        ? "Add Member"
                                        : "Loading..."
                                }
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddMemberDialog;
